import { clsx } from 'clsx'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { store } from 'store/store'
import css from './ShutterButton.module.scss'

type Props = {
  className?: string
  seconds?: number
  // Снимок идёт в фото в полный рост, а не в текущее селфи.
  photo?: boolean
}

// Круглая кнопка затвора поверх видео: по нажатию идёт отсчёт, затем снимок.
export const ShutterButton = observer(({ className, seconds = 3, photo }: Props) => {
  const { camera } = store.profile.common
  const counting = !!camera.seconds

  const onTake = useLatestCallback(async (e: React.MouseEvent) => {
    e.stopPropagation()
    if (counting) return
    await camera.countdown(seconds)
    await store.profile.common.take(photo)
    controller.closeSelfieBanner()
  })

  return (
    <button
      type="button"
      className={clsx(css.button, className)}
      title={i18n('TakePhoto')}
      disabled={!camera.canTake || camera.processing}
      onClick={onTake}
    >
      {counting && (
        <svg className={css.progress} viewBox="0 0 120 120">
          {/* pathLength=100 — чтобы dasharray считался в процентах независимо от размера */}
          <circle
            className={css.track}
            cx="60"
            cy="60"
            r="54"
            pathLength={100}
            style={{ '--duration': `${seconds}s` } as never}
          />
        </svg>
      )}
      {counting
        ? <span className={css.seconds}>{camera.seconds.toFixed()}</span>
        : <Icon className={css.icon} name="photo_camera" />}
    </button>
  )
})
